export enum SpotControlActionKey {
  ROTATION_AXES = 'RotationAxes',
}

export enum SpotControlRotationAxesKey {
  ROLL = 'roll',
  PITCH = 'pitch',
  YAW = 'yaw',
  HEIGHT = 'height',
}

export type SpotControlRotationAxesActionValue = Record<SpotControlRotationAxesKey, number>;
